import React from 'react';
import { motion } from 'framer-motion';
import { rail } from '../data/site';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Products() {
  return <section id="kaart" className="bg-cream px-6 py-20 lg:py-24" data-id="element-78" data-mp="3w14aqhk4ig8i">
      <div className="mx-auto max-w-6xl" data-id="element-79" data-mp="3r703dx6y466w">
        <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-80" data-mp="3n6pofv16e5fw">
          <div data-id="element-81" data-mp="3n6hby48yt258">
            <p className="text-sm text-clay" data-id="element-82" data-mp="3n4wr56cgcxkk">De kaart</p>
            <h2 className="mt-4 text-[clamp(2rem,4vw,3.25rem)] font-semibold leading-[1.05] tracking-[-0.03em] text-ink" data-id="element-83" data-mp="3i8fsvjbjh2tr">
              Vaste favorieten
            </h2>
          </div>
          <p className="max-w-sm text-base leading-relaxed text-mist" data-id="element-84" data-mp="388ozjkypstv9">
            Elke ochtend vers gebakken, wekelijks aangevuld met seizoensgebonden creaties.
          </p>
        </div>

        <ul className="mt-12 grid gap-x-6 gap-y-10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-85" data-mp="16ilsbjzots5b">
          {rail.map((item, i) => <motion.li key={item.id} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-10%'
        }} transition={{
          duration: 0.25,
          ease: EASE,
          delay: i % 3 * 0.05
        }} className="group flex flex-col" data-id="element-86" data-mp="12htlexeafzc7" data-mpi={i}>
              <div className="aspect-[4/5] w-full overflow-hidden rounded-2xl bg-sand" data-id="element-87" data-mp="zxy04skp6dka">
                <img src={item.image} alt={item.name} className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-88" data-mp="13z9gs8llfogc" />
              </div>
              <h3 className="mt-5 text-lg font-medium text-ink" data-id="element-89" data-mp="1iv8ubyrh2gsv">{item.name}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-mist" data-id="element-90" data-mp="1mvsr3184vieh">{item.note}</p>
            </motion.li>)}
        </ul>

        <p className="mt-12 text-center text-base text-mist" data-id="element-91" data-mp="2aktv8c9xo7dy">
          De volledige kaart vind je in de zaak.{' '}
          <a href="#bezoek" className="text-ink underline underline-offset-4 hover:text-clay" data-id="element-92" data-mp="2fdmzz05ejfq1">
            Plan je bezoek
          </a>
        </p>
      </div>
    </section>;
}